module.exports = __webpack_public_path__ + "static/og_image-b5b225dc809da9a2569ff91da6d3ec4f.png";